import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store';
import { updateCompanyProfilePicture, getCompanyProfile } from '../services/CompanyProfileService';
import swal from 'sweetalert';
import icon3 from "./../images/logo/icon3.jpg"

export function CompanySideBar() {
   const { auth, logout, updateUserProfile } = useAuthStore();

   const location = useLocation();

   const [isUploading, setIsUploading] = useState(false);
   const [previewUrl, setPreviewUrl] = useState(null);

   useEffect(() => {
      getCompanyProfile()
         .then(res => {
            const updatedUser = {
               ...auth.user,
               perfilEmpresa: res.data
            };
            updateUserProfile(updatedUser);
         })
         .catch(err => console.error('Error al cargar perfil de empresa:', err));
   }, []);

   // Verificar si la empresa está pendiente de aprobación
   const isPending = auth.user?.estado === 'PENDIENTE';

   const handleFileChange = async (e) => {
      const file = e.target.files[0];
      const inputElement = e.target; // Guardar referencia antes de operaciones asíncronas

      if (!file) return;

      // Validar tipo de archivo
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      if (!validTypes.includes(file.type)) {
         swal('Error', 'Por favor selecciona una imagen válida (JPG, PNG, GIF)', 'error');
         inputElement.value = '';
         return;
      }

      // Validar tamaño (máx 5MB)
      if (file.size > 5 * 1024 * 1024) {
         swal('Error', 'La imagen no debe superar los 5MB', 'error');
         inputElement.value = '';
         return;
      }

      setIsUploading(true);
      try {
         const response = await updateCompanyProfilePicture(file);

         // Obtener perfil actualizado del backend y reflejar en el estado local
         const profileRes = await getCompanyProfile();
         const updatedUser = {
            ...auth.user,
            perfilEmpresa: profileRes.data
         };
         updateUserProfile(updatedUser);
         setPreviewUrl(URL.createObjectURL(file));

         swal('¡Éxito!', response.data.message || 'Foto de perfil actualizada correctamente', 'success');
      } catch (error) {
         console.error('Error al subir la foto:', error);
         swal('Error', error.response?.data?.message || 'Error al actualizar la foto de perfil', 'error');
      } finally {
         setIsUploading(false);
         // Limpiar el input usando la referencia guardada
         inputElement.value = '';
      }
   };

   const items = [
      {
         text: 'Información de Perfil',
         to: '/company-profile',
         iconClassname: 'fa fa-user-o',
         disabled: false // Siempre habilitado
      },
      {
         text: 'Publicar una Vacante',
         to: '/company-post-jobs',
         iconClassname: 'fa fa-file-text-o',
         disabled: isPending
      },
      {
         text: 'Administrar Vacantes',
         to: '/company-manage-job',
         iconClassname: 'fa fa-briefcase',
         disabled: isPending
      },
      {
         text: 'Postulantes por vacante',
         to: '/company-applicants',
         iconClassname: 'fa fa-users',
         disabled: isPending
      },
      // {
      //    text: 'Postulaciones',
      //    to: '/company-resume',
      //    iconClassname: 'fa fa-id-card-o',
      //    disabled: isPending
      // },
      {
         text: 'Cambiar contraseña',
         to: '/company-change-password',
         iconClassname: 'fa fa-key',
         disabled: false // Siempre habilitado
      }
   ]

   return (
      <div className="col-xl-3 col-lg-4 m-b30">
         <div className="sticky-top">
            <div className="candidate-info company-info">
               <div className="candidate-detail text-center">
                  <div className="canditate-des">
                     <Link to={"#"}>
                        <img
                           alt="Logo de la empresa"
                           src={previewUrl || auth.user?.perfilEmpresa?.fotoPerfil || icon3}
                           style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              objectPosition: 'center'
                           }}
                        />
                     </Link>
                     <div
                        className="upload-link"
                        title={isUploading ? 'Subiendo...' : 'Actualizar foto'}
                        data-toggle="tooltip"
                        data-placement="right"
                        style={{ opacity: isUploading ? 0.5 : 1, cursor: isUploading ? 'wait' : 'pointer' }}
                     >
                        <input
                           type="file"
                           className="update-flie"
                           onChange={handleFileChange}
                           accept="image/jpeg,image/jpg,image/png,image/gif"
                           disabled={isUploading}
                        />
                        <i className={isUploading ? 'fa fa-spinner fa-spin' : 'fa fa-pencil'}></i>
                     </div>
                  </div>
                  <div className="candidate-title">
                     <h4 className="m-b5">
                        <Link to={"#"}>{auth.user?.perfilEmpresa?.razonSocial || auth.user?.nombre || '@COMPANY'}</Link>
                     </h4>
                  </div>
               </div>
               <ul>
                  {items.map((item, index) => (
                     <li key={index}>
                        {item.disabled ? (
                           <span
                              style={{
                                 cursor: 'not-allowed',
                                 opacity: 0.4,
                                 color: '#999',
                                 pointerEvents: 'none',
                                 display: 'block',
                                 padding: '10px 15px',
                                 textDecoration: 'line-through'
                              }}
                              title="Función no disponible - Cuenta pendiente de aprobación"
                           >
                              <i className={item.iconClassname} aria-hidden="true"></i>
                              <span style={{ marginLeft: '10px' }}>{item.text}</span>
                           </span>
                        ) : (
                           <Link to={item.to} className={location.pathname === item.to ? 'active' : ''}>
                              <i className={item.iconClassname} aria-hidden="true"></i>
                              <span>{item.text}</span>
                           </Link>
                        )}
                     </li>
                  ))}
                  <li>
                     <Link to={"./"} onClick={logout}>
                        <i className="fa fa-sign-out" aria-hidden="true"></i>
                        <span>Cerrar Sesión</span>
                     </Link>
                  </li>
               </ul>
            </div>
         </div>
      </div>
   )
}